export default {
    bgColor: 0x539f04,
    primaryKey: "BGElmnt_Dlr",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(data.scaleX, data.scaleY);
        image.alpha = 0;
        let deltaX = 1 - (data.x/bg.scene.size.width);
        image.setPosition(data.x - (350 * deltaX) - 100, data.y - (350 * deltaX) - 100);
        image.angle = data.angle;

        bg.scene.addTween(image, 700, {scaleX: data.scaleX, scaleY: data.scaleY}, "Back");
        bg.scene.addTween(image, 700, {alpha: 1, x: data.x, y: data.y}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 1200, {scaleX: .5, scaleY: .5, alpha: 0, x: image.x + (350 * deltaX) + 200, y: image.y + (350 * deltaX) + 200}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnt_Dlr",
            x: 487.37215189873416, y: 611.671729957806,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 994.6194092827004, y: 684.3949367088608,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 326.6430379746835, y: 690.3080168776371,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 788.6126582278481, y: 800.6616033755274,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 123.87004219409283, y: 785.8843881856541,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 101.10379746835443, y: 492.6928270042194,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 715.5037974683545, y: 508.97552742616034,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 27.924050632911392, y: 200.61518987341773,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 970.4236286919831, y: 393.77383966244724,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 897.1569620253165, y: 101.51139240506329,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 306.49620253164557, y: 377.49113924050636,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 486.915611814346, y: -30.679324894514764,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 281.4362869198312, y: 85.41350210970464,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 508.1113924050633, y: 280.97974683544305,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Dlr",
            x: 669.4329113924051, y: 203.66413502109705,
            angle: 24,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 508.1113924050633, y: 401.82278481012656,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 733.6506329113924, y: 410.3282700421941,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 865.1350210970464, y: 207.25654008438818,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 815.8793248945148, y: 303.0396624472574,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 301.71898734177216, y: 482.77974683544306,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 117.65822784810126, y: 381.8118143459916,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 244.68607594936708, y: 182.19662447257383,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 64.21772151898735, y: 590.9324894514768,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 932.8582278481013, y: 490.42109704641354,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 987.5704641350211, y: 281.25147679324897,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 482.1873417721519, y: 76.04388185654008,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 685.2590717299578, y: 615.4,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 806.5097046413503, y: 686.8514767932489,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 44.34261603375528, y: 102.10379746835443,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 636.1392405063291, y: 711.0472573839662,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 345.65400843881855, y: 520.073417721519,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 290.3493670886076, y: 565.0084388185654,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 534.0354430379747, y: 481.32320675105484,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 455.3991561181435, y: 487.37215189873416,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 153.81603375527428, y: 605.7586497890295,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 12.09789029535865, y: 624.7696202531646,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 80.36455696202532, y: 665.3839662447258,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 595.389029535865, y: 565.1443037974684,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 496.01350210970463, y: 739.6995780590718,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 593.6607594936709, y: 759.5746835443039,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 739.6995780590718, y: 674.0253164556963,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 877.0970464135021, y: 741.4278481012658,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 852.0371308016878, y: 617.8565400843881,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 951.4126582278482, y: 563.4160337552743,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 1020.5434599156118, y: 570.3291139240506,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 1023.135864978903, y: 505.5189873417722,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 884.0101265822785, y: 524.5299578059072,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 793.2759493670886, y: 427.746835443038,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 774.2649789029535, y: 349.1105485232068,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 677.4818565400844, y: 330.96371308016876,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 399.23037974683547, y: 328.37130801687766,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 332.6919831223629, y: 261.8329113924051,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 263.5611814345992, y: 257.51223628691986,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 164.18565400843883, y: 311.0886075949367,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 50.119831223628694, y: 367.25738396624473,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 187.51729957805907, y: 433.7957805907173,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 194.43037974683546, y: 216.0337552742616,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 105.42447257383967, y: 120.11476793248946,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 84.68523206751055, y: 43.20675105485232,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 369.8497890295359, y: 25.924050632911392,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 334.420253164557, y: 197.88691983122362,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 470.9535864978903, y: 157.27257383966244,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 525.3940928270042, y: 112.33755274261604,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 635.1392405063291, y: 80.36455696202532,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 715.5037974683545, y: 75.17974683544304,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 774.2649789029535, y: 156.4084388185654,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 919.4396624472574, y: 266.1535864978903,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 976.4725738396625, y: 19.01097046413502,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 216.89789029535865, y: 736.2430379746836,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 149.49535864978904, y: 669.704641350211,
            angle: 0,
            scaleX: 0.6999999999999997, scaleY: 0.6999999999999997
        }, {
            key: "BGElmnt_Cns",
            x: 127.75611814345993, y: -5.49451476793249,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 687.9873417721519, y: -7.271729957805906,
            angle: 0,
            scaleX: 1, scaleY: 1
        }, {
            key: "BGElmnt_Cns",
            x: 914.2548523206751, y: 1.5924050632911393,
            angle: 0,
            scaleX: 1, scaleY: 1
        }
    ]
}